/* Buluşma bileti — kontenjan tazeleyici
 *
 * Sorun: Shopify sayfa ciktisini onbellekliyor. Envanter degisse bile sayfa
 * eski sayiyi gostermeye devam edebiliyor — olculdu: stok 19 iken site 17
 * gosteriyordu.
 *
 * Cozum: sayfa acilinca bolum kendi HTML'ini Section Rendering API uzerinden,
 * onbellek kirici bir parametreyle yeniden ister ve yalnizca sayac/kilit
 * durumunu gunceller. Storefront API veya token gerekmez.
 *
 * API cevap vermezse sayfa oldugu gibi kalir; fazla satisi engelleyen asil
 * kilit zaten sunucu tarafinda calisiyor.
 */

(() => {
  const bolum = document.querySelector('[data-bilet-kontenjan]');
  if (!bolum) return;

  const sectionId = bolum.dataset.sectionId;
  if (!sectionId) return;

  const adres =
    window.location.pathname +
    '?sections=' +
    encodeURIComponent(sectionId) +
    '&_dk=' +
    Date.now();

  fetch(adres, { cache: 'no-store', headers: { 'Cache-Control': 'no-cache' } })
    .then(function (r) {
      return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status));
    })
    .then(function (j) {
      const html = j && j[sectionId];
      if (!html) return;

      const taze = new DOMParser().parseFromString(html, 'text/html');
      const tazeSatirlar = taze.querySelectorAll('.bilet__day');
      const mevcutSatirlar = bolum.querySelectorAll('.bilet__day');
      if (!tazeSatirlar.length || tazeSatirlar.length !== mevcutSatirlar.length) return;

      tazeSatirlar.forEach(function (tazeSatir, i) {
        const satir = mevcutSatirlar[i];
        const tazeKalan = tazeSatir.querySelector('.bilet__day-left');
        const kalan = satir.querySelector('.bilet__day-left');
        if (tazeKalan && kalan) kalan.textContent = tazeKalan.textContent.trim();

        const dolu = tazeSatir.classList.contains('is-sold-out');
        satir.classList.toggle('is-sold-out', dolu);

        const input = satir.querySelector('.bilet__day-input');
        const tazeInput = tazeSatir.querySelector('.bilet__day-input');
        if (input && tazeInput) input.disabled = tazeInput.disabled;
      });

      // Satin alma butonunun durumu da taze render'dan alinir.
      const buton = bolum.querySelector('button.bilet__cta');
      const tazeButon = taze.querySelector('button.bilet__cta');
      if (buton && tazeButon) {
        buton.disabled = tazeButon.disabled;
        buton.textContent = tazeButon.textContent.trim();
      }
    })
    .catch(function () {
      /* Sessizce mevcut degerlerde kal. */
    });
})();
